// Vuex
import store from '@/store.js';

import Request from './request';

async function my(noLoading) {// 检查本地accessToken的登录状态
    const response = await Request('get', "api/account-users/my",null,noLoading);
    if (response.data && response.data.status.isOK()) {
        store.commit("USERINFO", response.data);
        localStorage.setItem("pushMidURL", response.data.settings.push_mid_url);
    }
    return response;
}

export default {
    my
};